/** Lê um File do navegador e devolve só o payload base64 (sem o prefixo data:). */
export function lerBase64(arquivo: File): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const leitor = new FileReader();
    leitor.onload = () => resolve(String(leitor.result).split(',')[1] ?? '');
    leitor.onerror = () => reject(new Error('Falha ao ler o arquivo'));
    leitor.readAsDataURL(arquivo);
  });
}

/** Converte a lista de Files no formato de anexo que o backend espera. */
export async function arquivosParaAnexos(arquivos: File[]) {
  return Promise.all(
    arquivos.map(async (a) => ({ nome_arquivo: a.name, conteudo_base64: await lerBase64(a) }))
  );
}
